import { StrictMode, Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import { Toaster } from 'sonner';
import { ConfigProvider, isStaffHost } from '@/lib/config';
import { SessionProvider } from '@/lib/session';
import './styles.css';
import { Loading } from '@/components/app/feedback';
import { TooltipProvider } from '@/components/ui/tooltip';

// One app, two hosts (§1.1): `admin.` is the staff site. Each site is its own chunk, so players
// never download the staff pages.
const staff = isStaffHost(window.location.hostname);
const Site = lazy(() => (staff ? import('./staff/StaffApp') : import('./site/SiteApp')));

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ConfigProvider>
      <SessionProvider>
        <TooltipProvider>
          <Suspense fallback={<Loading />}>
            <Site />
          </Suspense>
          <Toaster richColors closeButton position="bottom-right" />
        </TooltipProvider>
      </SessionProvider>
    </ConfigProvider>
  </StrictMode>,
);
